import { FileUploader } from "../../components/fileUploader";
import { Preview } from "../../components/preview";
import "../../assets/css/components.css";
import { CollapsibleContainer } from "../../components/collapsibleContainer";

export const MediaUploaderPreview = ({
  type = "image",
  accept = "image/*",
  onChange,
  multiple = true,
  name,
  placeholder,
  errorMsg,
  newList,
  currentList,
}) => {
  return (
    <div>
      <FileUploader
        type="file"
        accept={accept}
        onChange={onChange}
        multiple={multiple}
        name={name}
        placeholder={placeholder}
        errorMsg={errorMsg}
      />
      <CollapsibleContainer
        element={
          <Preview newList={newList} currentList={currentList} type={type} />
        }
      />
    </div>
  );
};
